import { z } from "zod";

import { decimalCompare, decimalSum, positiveDecimalSchema, type DecimalValue } from "../values/decimal";
import { BATCH_SPLIT_COPY } from "./inventory-copy";

export const BATCH_SPLIT_MESSAGES = BATCH_SPLIT_COPY;

export const splitChemicalSchema = z.object({
  children: z.array(z.object({
    batchNumber: z.string(),
    quantity: positiveDecimalSchema,
  })).min(1, BATCH_SPLIT_MESSAGES.noChildren),
});

export function splitOverdrawIssue(children: readonly { quantity: DecimalValue }[], parentAmount: DecimalValue): string | null {
  const requested = decimalSum(children.map((child) => child.quantity));
  return decimalCompare(requested, parentAmount) > 0 ? BATCH_SPLIT_MESSAGES.overdraw(String(requested), String(parentAmount)) : null;
}
